module.exports = __webpack_public_path__ + "img/figure-7.f9e23ffc.png";